


window.HEH_GIFT_HANDLE = 'heh-paws-wooden-scoop-1-tsp';
window.HEH_PROMO_END   = new Date('2025-11-18T23:59:59-07:00').getTime(); // change if needed

(function () {
  if (Date.now() > window.HEH_PROMO_END) return;

  function getGiftId(){
    return new Promise(function(resolve){
      if (window.HEH_GIFT_ID) return resolve(window.HEH_GIFT_ID);
      fetch('/products/' + window.HEH_GIFT_HANDLE + '.js', {credentials:'same-origin'})
        .then(function(r){ return r.json(); })
        .then(function(p){
          var id = p && p.variants && p.variants.length ? p.variants[0].id : null;
          if (id) window.HEH_GIFT_ID = id;
          resolve(id);
        })
        .catch(function(){ resolve(null); });
    });
  }

  function hasGift(items, id){ return items.some(function(i){ return i.variant_id === id; }); }
  function nonGiftQty(items, id){
    return items.filter(function(i){ return i.variant_id !== id; })
                .reduce(function(n,i){ return n + i.quantity; }, 0);
  }

  function ensureGift(){
    return getGiftId().then(function(GIFT_ID){
      if (!GIFT_ID) return;

      return fetch('/cart.js', {credentials:'same-origin'})
        .then(function(r){ return r.json(); })
        .then(function(cart){
          var has   = hasGift(cart.items, GIFT_ID);
          var need  = nonGiftQty(cart.items, GIFT_ID) > 0 && !has;      // add one if any non-gift item
          var only  = nonGiftQty(cart.items, GIFT_ID) === 0 && has;     // remove if scoop is the only item

          if (need){
            return fetch('/cart/add.js', {
              method:'POST',
              headers:{'Content-Type':'application/json'},
              credentials:'same-origin',
              body: JSON.stringify({
                id: GIFT_ID,
                quantity: 1,
                properties: {'_free_gift':'Launch gift'}
              })
            }).then(function(){
              document.dispatchEvent(new Event('cart:refresh'));
              document.dispatchEvent(new Event('cart:updated'));
            });
          }

          if (only){
            return fetch('/cart/change.js', {
              method:'POST',
              headers:{'Content-Type':'application/json'},
              credentials:'same-origin',
              body: JSON.stringify({ id: GIFT_ID, quantity: 0 })
            }).then(function(){
              document.dispatchEvent(new Event('cart:refresh'));
              document.dispatchEvent(new Event('cart:updated'));
            });
          }
        });
    });
  }

  function hook(){
    document.body.addEventListener('submit', function(e){
      if (e.target && e.target.matches('form[action*="/cart/add"]')) {
        setTimeout(ensureGift, 500);
        setTimeout(ensureGift, 1200);
        setTimeout(ensureGift, 2500);
      }
    }, true);

    document.body.addEventListener('click', function(e){
      if (e.target.closest('form[action*="/cart/add"]') || e.target.name === 'add' || e.target.closest('[data-add-to-cart]')){
        setTimeout(ensureGift, 500);
        setTimeout(ensureGift, 1200);
        setTimeout(ensureGift, 2500);
      }
      if (e.target.closest('[data-quantity-button]') || e.target.closest('.quantity') ){
        setTimeout(ensureGift, 600);
      }
    }, true);

    document.addEventListener('cart:open', ensureGift);
    document.addEventListener('cart:updated', ensureGift);
  }

  document.addEventListener('DOMContentLoaded', function(){
    ensureGift();
    setTimeout(ensureGift, 800);
    setTimeout(ensureGift, 2000);
    hook();
  });
})();
